import { IDevice } from '~/services/api/devices/types';

export const getDevicesNamesList = (devices: IDevice[], devicesIds: number[]) =>
  devices.filter(x => devicesIds.includes(x.id)).map(x => `${x.typeName} - ${x.imei}`);

export default {};
